import { postDashboardAlertLatest } from "api/dashboardAPI";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import Spinner from "components/atoms/loader/Spinner";
import AlertList from "pages/dashboard/common/alerts/AlertList";
import { useQuery } from "react-query";
import { useMediaQuery } from "react-responsive";
import { useAppSelector } from "redux/hooks";
import { COLORS } from "styles/colors";
import { FaCircleCheck } from "react-icons/fa6";
import * as s from "../AlertViewStyled";
interface Props {
  recorderId: string;
}

export default function AlertWaringInfo(props: Props) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const isDesktop = useMediaQuery({ query: "(min-width: 1024px)" });
  const { data, isLoading } = useQuery(
    ["getAlertLatest", selectedAccount],
    () =>
      postDashboardAlertLatest({
        accountId: selectedAccount.accountId,
        maxCount: isDesktop ? 30 : 5,
        payload: {
          accountIds: [],
          keyword: "",
        },
      }),
    {
      retry: 0,
      // refetchInterval: 10000,
      refetchOnWindowFocus: false,
    }
  );
  if (isLoading) {
    return <Spinner />;
  }
  if (
    (data?.result || []).filter(
      (item: any) => item.recorderId === props.recorderId
    ).length === 0
  ) {
    return (
      <s.AlertViewNoData>
        <FaCircleCheck color={COLORS.GREEN} size={42} />
        No Alert
      </s.AlertViewNoData>
    );
  }
  return (
    <AlertList
      data={(data?.result || []).filter(
        (item: any) => item.recorderId === props.recorderId
      )}
    />
  );
}
